import React from "react";
import { Modal } from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";

const ShowMultipleBatchesModal = ({ show, onHide, batchData }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="pe-7s-info" style={{ marginRight: "10px" }}></i>
          Select Batch
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ padding: "20px" }}>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Batch No</th>
                <th>Expiry Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {batchData && batchData.length > 0 ? (
                batchData.map((batch, index) => (
                  <tr key={index}>
                    <td>{batch.batch_no || "N/A"}</td>
                    <td>{batch.expiry_date || "N/A"}</td>
                    <td>
                      <Button
                        bsSize="small"
                        fill
                        onClick={() => {
                          onHide(batch);
                        }}
                      >
                        Select
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    No batches available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} fill bsStyle="warning">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShowMultipleBatchesModal;
